import React, { useCallback, useEffect } from 'react';
import styled from 'styled-components';
import { Colors } from '@client/style/Variables';
import { SquareButton } from '../shared/SquareButton';
import { OverlayController, Overlays } from '@client/core/modules/Overlays/Overlays';
import { OverlayRegisterPrompt } from '../overlays/RegisterPrompt/OverlayRegisterPrompt';
import RegistrationStore from './RegistrationStore';
import { TextStyleBody } from '@client/style/Shared';

const Container = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	position: relative;
	align-items: center;
	padding: 0 var(--gridMargin);
	padding-bottom: 20px;

	&:has(+ .BreakerModule) {
		border-bottom: var(--breaker-total) solid transparent;
	}
`;
const Text = styled.p`
	${TextStyleBody}
	margin-bottom: 30px;
`;

export default function MyPageRegistration() {
	const registered = RegistrationStore.use(state => state.registered);

	const openOverlay = useCallback(() => {
		Overlays.Instance.open({
			create: (controller: OverlayController) => {
				return <OverlayRegisterPrompt controller={controller} />;
			},
		});
	}, [Overlays.Instance]);

	useEffect(() => {
		RegistrationStore.load();
	}, []);

	if (registered === undefined) return;

	return (
		<Container>
			<Text>
				{registered
					? 'Du har forbundet et armbånd. Fjern eller ændre forbindelsen her.'
					: 'Har du fået et armbånd? Forbind det til din konto her!'}
			</Text>
			<SquareButton
				colors={{
					bg: Colors.darkBackground,
					fg: Colors.lightText,
				}}
				onClick={openOverlay}
			>
				{registered ? 'Ændre armbånd' : 'Forbind dit armbånd!'}
			</SquareButton>
		</Container>
	);
}
